<template>
  <v-menu
    v-model="menu"
    transition="slide-y-transition"
    :close-on-content-click="false"
    offset-y
    full-width
    top>

    <v-text-field
      slot="activator"
      @click.stop="menu = true"
      :value="value.text"
      label="學校"
      prepend-icon="account_balance"
      color="black"
      readonly />

    <v-card class="school-menu-card">
      <v-text-field
        v-model="schoolKeyword"
        class="school-menu-card__search"
        color="black"
        :loading="loading"
        placeholder="搜尋學校"
        prepend-inner-icon="search"
        clearable />

      <v-list class="pa-0 overflow-y-auto">
        <v-list-tile
          v-for="option in schoolOptions"
          :key="option.text"
          @click="onSelect(option)">

          <v-list-tile-content>
            {{option.text}}
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  data() {
    return {
      loading: false,
      menu: false,
      schoolKeyword: '',
      schoolOptions: []
    };
  },

  props: {
    value: {
      default: {}
    },
    schoolSystemName: {
      type: String,
      required: true
    }
  },

  watch: {
    schoolSystemName() {
      this.schoolKeyword = '';
      this.schoolOptions = [];
    },

    schoolKeyword(value) {
      clearTimeout(this._searchTimeout);
      if (!value) {
        return;
      }
      this._searchTimeout = setTimeout(async () => {
        this.loading = true;
        try {
          this.schoolOptions = await this.getSchools({
            term: value,
            schoolsystem: this.schoolSystemName
          });
        } catch (e) {
          console.error('query schools failed', e);
        } finally {
          this.loading = false;
        }
      }, 500);
    }
  },

  methods: {
    ...mapActions('user', {
      getSchools: 'getSchools'
    }),

    onSelect(option) {
      this.menu = false;
      this.$emit('input', option);
    }
  }
};
</script>

<style lang="stylus" scoped>
.school-menu-card {
  max-height: 200px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0 1rem 1rem 1rem;
  background-color: white;
}

.school-menu-card__search {
  flex-grow: 0;
  flex-shrink: 0;
}
</style>
